import { config } from "@/lib/config";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export default function AboutMe() {
  const [showDetails, setShowDetails] = useState(false);

  const handleDetailsClick = () => {
    setShowDetails(!showDetails);
  };

  const icon = <i className="bi bi-dot beart-icon1"></i>;
  return (
    <section className="mx-auto mt-8 flex w-3/4 flex-grow flex-col bg-[#ffcc99] bg-opacity-50 text-black shadow md:flex-row md:rounded-lg">
      <div className="md:min-w-1/3 w-full flex-1 content-center md:w-fit">
        <img
          src={`${config.basePath}/images/beart-coach-pic.webp`}
          alt="BeArt"
          className="h-[100%] w-[100%] object-cover md:rounded-l-lg"
        />
      </div>
      <div className="flex-2 md:min-w-2/3 w-full md:w-2/3">
        <div className="p-4">
          <h2 className="mb-4 text-xl font-bold">Rólam</h2>
          <div className="mb-8 italic">
            <span className="text-xl not-italic">Bíró Beáta</span> &mdash;
            Művészetterápiás csoportvezető, life és art coach, mentálhigiénés
            szakember, integrál szemléletű önismereti csoportvezető és
            családállító vagyok.
          </div>
          <div className="">
            A <strong>művészetterápiás foglalkozásokban</strong> azt szerettem a
            legjobban, hogy az alkotásokban megjelenhetnek nemcsak a tudatos,
            hanem a tudattalan belső tartalmaink, amiket kívülről szemlélve
            felismerhetőek és kimondhatóak lesznek és így ráláthatunk belső
            mozgatórugóinkra, mélyebb önismeretet ad.
          </div>
          {!showDetails && (
            <div className="mt-4 font-bold">
              <Button
                onClick={handleDetailsClick}
                className="bg-red-900 bg-opacity-75 hover:bg-red-700"
              >
                Bővebben...
              </Button>
            </div>
          )}
          {showDetails && (
            <div className="mt-4 animate-fade-down animate-duration-300 animate-ease-in-out">
              <div className="mb-2">
                Az első művészetterápiás alkotásomat 19 éves koromban
                készítettem. A mai napig emlékszem a képre, ami sorsfordító
                hatással volt az életemre. Hosszú évtizednyi tapasztalatot
                gyűjtöttem, mire újra a művészetterápia felé nyílt az utam.
                Sorsfordító változások indítottak el egy mélyebb önismereti
                úton, ami a művészetterápia irányába terelt.
              </div>
              <div className="mb-4">
                A művészetterápiás csoportokat szupervízió mellett vezetem.
                Kapcsolati nehézségek, konfliktusok, önbizalom problémák,
                különböző életterületi elakadások, túlzott stressz okozta
                problémák miatt keresnek meg főként a csoportokba jelentkezők és
                az egyéni kliensek. Örömteli látni a változást, amit a
                résztvevők az életükben megélnek.
              </div>
              <div className="mb-4">
                <strong>Szervezetek számára</strong> egyéni és csoportos
                fejlesztési programokat (coaching, mentoring). Cégek számára az
                art coaching módszerével is segítem a szervezetfejlesztési
                folyamataikat. Művészetterápiás kiégés prevenciós programom
                beépíthető a munkahelyi mentálhigiénés fejlesztésekbe (csoportos
                és egyéni fejlesztésekbe is egyaránt).
              </div>

              <div className="mb-4">
                <div className="mb-4">
                  <div className="beart-subtitle">Szakmai képzések</div>
                  <ul className="list-outside">
                    <li className="flex">
                      {icon}
                      <div>
                        Művészetterápiás csoportvezető, szocioterapeuta,
                        közösségépítő (2021&mdash;2024)
                      </div>
                    </li>
                    <li className="flex">
                      {icon}
                      <div>Mentálhigiénés szakember (2022&mdash;2023)</div>
                    </li>
                    <li className="flex">
                      {icon}
                      <div>
                        Integrál szemléletű család- és rendszerállító
                        (2022&mdash;2023)
                      </div>
                    </li>
                    <li className="flex">
                      {icon}
                      <div>
                        Integrál szemléletű önismereti csoportvezető (2020)
                      </div>
                    </li>
                    <li className="flex">
                      {icon}
                      <div>Coaching továbbképzések (2020&mdash;2021)</div>
                    </li>
                    <li className="flex">
                      {icon}
                      <div>Integrál pszichológia (2019&mdash;2022)</div>
                    </li>
                    <li className="flex">
                      {icon}
                      <div>I-coaching (2019)</div>
                    </li>
                    <li className="flex">
                      {icon}
                      <div>Life- és Art coaching (2019)</div>
                    </li>
                  </ul>
                </div>
                <div className="">
                  <img
                    src={`${config.basePath}/images/csoportkep.jpg`}
                    alt="Csoportkép"
                    className="mx-auto rounded-lg"
                    width="65%"
                  />
                </div>
              </div>

              <div className="mt-4 font-bold">
                <Button
                  onClick={handleDetailsClick}
                  className="bg-red-900 bg-opacity-75 hover:bg-red-700"
                >
                  Kevesebb...
                </Button>
              </div>
            </div>
          )}
          <h2 className="beart-title">Miben tudok segíteni</h2>
          <ul className="list-outside">
            <li className="flex">
              <i className="bi bi-check-circle-fill beart-icon1"></i>{" "}
              <div>Ha úgy érzed elakadtál életed egy területén,</div>
            </li>
            <li className="flex">
              <i className="bi bi-check-circle-fill beart-icon1"></i>{" "}
              <div>Döntés előtt állsz és nem tudod merre indulj,</div>
            </li>
            <li className="flex">
              <i className="bi bi-check-circle-fill beart-icon1"></i>{" "}
              <div>Változtatni szeretnél, de nem tudod hogyan kezdj neki,</div>
            </li>
            <li className="flex">
              <i className="bi bi-check-circle-fill beart-icon1"></i>{" "}
              <div>Szeretnéd jobban megismerni önmagad</div>
            </li>
          </ul>

          <div className="">
            <div className="mb-2 mt-4 font-bold">Mottóm</div>
            <div>
              „Furcsa paradoxon, hogy amikor elfogadom magamat, olyannak amilyen
              valójában vagyok, képes vagyok megváltozni!” &mdash; Carl R.
              Rogers
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
